import React from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { get } from 'lodash';
import correctIcon from 'assets/images/correct.png';
import './style.scss';

const ScraWaiverComplete = () => {
  const { loanId } = useParams();
  const location = useLocation();
  const externalId = get(location, 'state.externalId') || loanId;

  return (
    <div className="thankyou-wrapper">
      {externalId ? (
        <div>
          <p className="mb-0 p-large">
            <b>Loan ID:</b>
            {' '}
            {externalId}
          </p>
        </div>
      ) : null}
      <div className="thankyou-inner-wrapper text-center">
        <img src={correctIcon} alt="Complete" />
        <h2>Thank You!</h2>
        <p className="p-large">We will email you the SCRA waiver confirmation, once the waiver terms are applied on your loan.</p>
      </div>
    </div>
  );
};

ScraWaiverComplete.propTypes = {};

ScraWaiverComplete.defaultProps = {};

export default ScraWaiverComplete;
